import {
  NIBreadcrumbArrowIcon,
  NIBreadcrumbHomeIcon,
} from '@native-instruments/webex-ni';
import { Link } from 'react-router';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import env from '~/env';

type Breadcrumb = {
  name: string;
  path: string;
};

export function Breadcrumbs({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) {
  return (
    <ol
      data-testid="breadcrumbs"
      className={clsx(
        'flex text-grey-60 text-xs py-3',
        'col-span-4',
        'lg:col-span-8',
        'xl:col-span-12',
      )}
    >
      {breadcrumbs.map(({ name, path }, i) => {
        const isFirst = i === 0;
        const isLast = i === breadcrumbs.length - 1;
        const isExternal = i < 2;
        return (
          <li
            key={`breadcrumb-${name}`}
            className="flex items-center"
            data-testid={`breadcrumb-${name}`}
          >
            <CustomLink to={path} isExternal={isExternal}>
              <div className="transition-colors ease-out duration-0.15 hover:text-grey-90 hover:underline">
                {isFirst ? <NIBreadcrumbHomeIcon /> : name}
              </div>
            </CustomLink>

            {!isLast && (
              <div className="px-1">
                <NIBreadcrumbArrowIcon />
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
}

const CustomLink = ({
  to,
  isExternal = false,
  children,
}: {
  to: string;
  isExternal?: boolean;
  children: ReactNode;
}) => {
  if (isExternal) return <a href={env.APP_BASE_URL + to}>{children}</a>;

  return (
    <Link className="text-grey-90 underline" to={to}>
      {children}
    </Link>
  );
};
